import { JSGraph as OriginalJSGraph } from 'common-spectrum';

import { getAnnotations } from './jsgraph/getAnnotations';

export { Analysis, AnalysesManager, fromJcamp, toJcamp } from 'common-spectrum';

export { autoPeakPicking } from './autoPeakPicking';

export * from './from/fromPanalytical';

export { references } from './references';

export const JSGraph = { ...OriginalJSGraph, getAnnotations };
